import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, saveToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=unauth, object=authed
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    setError("");
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) saveToken(data.token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    setError("");
    const { data } = await api.post("/auth/register", payload);
    if (data && data.waitlisted) {
      // Waitlist mode — no session created. Caller renders confirmation UI.
      return data;
    }
    if (data.token) saveToken(data.token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* noop */
    }
    saveToken(null);
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, refresh, error, setError }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  return useContext(AuthCtx);
}
